export default "__VITE_ASSET__BvKYy2_Y__"